.hero {
  text-align: center;
  max-height: 100%;
  width: auto;
  width: 100%;
  margin-bottom: 70px;
  margin-top: 20px;
}